module.exports = __webpack_public_path__ + "static/media/camera_view_right.8fe98b27.svg";